/**
 * Konvertiert das Backend-Array von Risk-Characteristics in das flache
 * `Answers`-Shape (key → value), das die Step-Forms (RisikoKfzStepForm,
 * RisikoImmobilieStepForm) als `initialAnswers` erwarten.
 *
 * Backend liefert für jedes RiskObject `characteristics: [{ nameBezeichnung,
 * riskCharacteristicValue }, …]` — die Forms arbeiten mit `Record<string, string>`.
 */
export const characteristicsToAnswers = (
  characteristics: ReadonlyArray<{
    nameBezeichnung?: string | null;
    riskCharacteristicValue?: string | null;
  } | null | undefined> | null | undefined,
): Record<string, string> => {
  const out: Record<string, string> = {};
  if (!characteristics) return out;
  for (const c of characteristics) {
    if (c?.nameBezeichnung) {
      out[c.nameBezeichnung] = c.riskCharacteristicValue ?? "";
    }
  }
  return out;
};
